export const STEP_MINIMUM_HEIGHT = '16rem';
